<template>
    <div class="field-guide" v-if="fieldGuide">
        <header class="guide-header" :style="headerStyle">
            <div class="text-center">
                <h2>{{ fieldGuide.title }}</h2>
                <h3><fa-icon :icon="['fal', 'grip-lines']" /> a Field Guide by <BetterLink :to="{ name: 'User Profile', params: { slug: fieldGuide.user.slug } }">{{ fieldGuide.user.name }}</BetterLink> <fa-icon :icon="['fal', 'grip-lines']" /></h3>
            </div>
            <p v-html="$autoP(fieldGuide.description)"></p>
        </header>
        
        <div class="container-fluid my-5 py-5 d-print-none">
            <h2 class="text-center mb-5 text-muted">What kind of info is in here?</h2>
            <div class="guide-fun-stats row">
                <div class="stat col-sm mb-4 mb-sm-0">
                    <div class="counter">
                        {{ stateCount }}
                    </div>
                    <div class="label">{{ stateCount | withDeclensionalWord('State', 'States', false) }}</div>
                </div>
                <div class="stat col-sm mb-4 mb-sm-0">
                    <div class="counter">
                        {{ siteCount }}
                    </div>
                    <div class="label">Hot Springs</div>
                </div>
                <div class="stat col-sm mb-4 mb-sm-0" v-if="isLoggedIn">
                    <div class="counter">
                        {{ unvisitedCount }}
                    </div>
                    <div class="label">You Haven't Visited</div>
                </div>
                <div class="stat col-sm mb-4 mb-sm-0">
                    <div class="counter">
                        {{ poolCount }}
                    </div>
                    <div class="label">{{ poolCount | withDeclensionalWord('Pool', 'Pools', false) }}</div>
                </div>
            </div>
        </div>
        
        <div v-for="(entry, index) in fieldGuide.entries" :key="entry.id" class="entry">
            <component :is="componentFileFor(entry)" :entry="entry" :index="index" />
        </div>
        
        <footer class="guide-footer container-fluid text-center py-5">
            <small><em>This guide was put together by <BetterLink :to="{ name: 'User Profile', params: { slug: fieldGuide.user.slug } }">{{ fieldGuide.user.name }}</BetterLink>. It is provided as is, and is for informational purposes only. It may be out of date or incorrect.</em></small>
        </footer>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import axios from 'axios'
import GAMixins from '@/mixins/GAMixins'
import EntryBlocks from './entry-blocks'

export default {
    name: 'FieldGuide',
    mixins: [
        GAMixins,
    ],
    head: {
        title() {
            return {
                inner: this.fieldGuide && this.fieldGuide.title ? `${this.fieldGuide.title}, a Field Guide by ${this.fieldGuide.user.name}` : 'Field Guide',
            }
        },
        // meta() {
        //     const baseUrl = location.protocol+'//'+location.hostname
        //     const title = this.site && this.site.name ? `${this.site.name} • ${this.site.location.formatted_locality}` : 'drench. - Find Hot Springs'
        //     const imageAlt = this.site && this.site.name ? `Photo of ${this.site.name}` : 'Photo from drench. - Find Hot Springs'
        //     const link = this.site && this.site.slug ? `${baseUrl}/sites/${this.site.slug}` : baseUrl
        //     const description = this.site && this.site.name ? (this.site.short_description || this.site.description) : 'The best directory of hot springs.'
        //     const twitterParams = '?w=1200&h=600&fit=crop&crop=faces,entropy'
        //     const twitterImage = this.site && this.site.photos.length ? 'https:' + this.site.photos[0].permalink + twitterParams : `https://drench.imgix.net/media/drench-site-no-image.jpg${twitterParams}`
        //     const facebookParams = '?w=1200&w=630&fit=crop&crop=faces,entropy'
        //     const facebookImage = this.site && this.site.photos.length ? 'https:' + this.site.photos[0].permalink + facebookParams : `https://drench.imgix.net/media/drench-site-no-image.jpg${facebookParams}`
            
        //     return [
        //         { id: 'twitter:card', name: 'twitter:card', content: 'summary_large_image' },
        //         { id: 'twitter:site', name: 'twitter:site', content: title },
        //         { id: 'twitter:title', name: 'twitter:title', content: title },
        //         { id: 'twitter:description', name: 'twitter:description', content: description },
        //         { id: 'twitter:image:src', name: 'twitter:image:src', content: twitterImage },
                
        //         { id: 'og:title', name: 'og:title', content: title, 'xmlns:og': 'http://opengraphprotocol.org/schema/' },
        //         { id: 'og:url', name: 'og:url', content: link, 'xmlns:og': 'http://opengraphprotocol.org/schema/' },
        //         { id: 'og:description', name: 'og:description', content: description, 'xmlns:og': 'http://opengraphprotocol.org/schema/' },
        //         { id: 'og:image', name: 'og:image', content: facebookImage, 'xmlns:og': 'http://opengraphprotocol.org/schema/' },
        //         { id: 'og:image:width', name: 'og:image:width', content: '1200', 'xmlns:og': 'http://opengraphprotocol.org/schema/' },
        //         { id: 'og:image:height', name: 'og:image:height', content: '630', 'xmlns:og': 'http://opengraphprotocol.org/schema/' },
        //         { id: 'og:image:alt', name: 'og:image:alt', content: imageAlt, 'xmlns:og': 'http://opengraphprotocol.org/schema/' },
        //         { id: 'og:site_name', name: 'og:site_name', content: 'drench.', 'xmlns:og': 'http://opengraphprotocol.org/schema/' },
        //         { id: 'og:type', name: 'og:type', content: 'website', 'xmlns:og': 'http://opengraphprotocol.org/schema/' },
        //         { id: 'fb:app_id', name: 'fb:app_id', content: '371976654036508', 'xmlns:og': 'http://www.facebook.com/2008/fbml' },
        //     ]
        // },
    },
    data() {
        return {
            fieldGuide: null,
        }
    },
    computed: {
        ...mapState('account', ['userProfile']),
        ...mapGetters('account', ['isLoggedIn']),

        headerStyle() {
            return this.fieldGuide.photos.length
                ? `background: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.7)), url(${this.fieldGuide.photos[0].permalink});` 
                : ''
        },
        siteCount() {
            return this.fieldGuide.entries.filter(entry => entry.site != null).length
        },
        poolCount() {
            return this.fieldGuide.entries.reduce((accum, entry) => {
                return accum + entry.site.number_of_pools
            }, 0)
        },
        stateCount() {
            let regions = []
            return this.fieldGuide.entries.reduce((accum, entry) => {
                let count = 0
                if (regions.indexOf(entry.site.region) == -1) {
                    count = 1
                    regions.push(entry.site.region)
                }
                return accum + count
            }, 0)
        },
        unvisitedCount() {
            return this.fieldGuide.entries.reduce((accum, entry) => {
                return accum + entry.site && entry.site.is_visited == 0 ? 1 : 0
            }, 0)
        },
    },
    methods: {
        loadData() {
            let loader = this.$loading.show();
            axios({
                url: process.env.VUE_APP_API_BASE_URL + '/field-guides/' + this.$route.params.id,
                method: 'GET',
            }).then(response => {
                this.fieldGuide = response.data.data;
                this.$emit('updateHead')
                this.gaTrackScreenView(this.fieldGuide.title)
                loader.hide()
            }).catch(error => {
                console.log({ error: error })
                if (error.response.status == 404) {
                    this.$router.replace('/404')
                }
                loader.hide()
            })
        },
        componentFileFor(entry) {
            if (entry.site != null) {
                return EntryBlocks.Site
            }
            return EntryBlocks.Default
        },
    },
    created() {
        this.loadData()
    }
};
</script>

<style lang="scss" scoped>
.field-guide {
    .guide-header {
        margin-top: -24px;
        background: $primary;
        background-position: center center;
        background-size: cover;
        padding: 100px 10%;
        color: white;
        
        h2 {
            font-family: "Salome Fine";
            font-size: 8vw;
            line-height: 8.2vw;
        }
        h3 {
            margin: 40px 0;
            text-transform: none;
            font-size: 2vw;
            line-height: 2vw;
            font-style: italic;
            
            a {
                color: white;
                text-decoration: underline;
                
                &:hover {
                    text-decoration: none;
                    background: white;
                    color: black;
                    transition: all 0.3s ease;
                }
            }
        }
        p {
            font-size: 18px;
        }
    }
    
    .guide-fun-stats {
        .stat {
            text-align: center;
            font-size: 150%;
            text-transform: uppercase;
            
            .counter {
                position: relative;
                font-size: 250%;
                font-weight: bold;
                border-radius: 50%;
                width: 140px;
                height: 140px;
                line-height: 140px;
                margin: 0 auto 20px;
                background: $primary;
                color: white;
                
                &:after {
                    content: "";
                    border: 1px dotted $primary;
                    width: 148px;
                    height: 148px;
                    position: absolute;
                    top: -4px;
                    left: -4px;
                    border-radius: 50%;
                }
            }
        }
    }
    
    .guide-footer {
        margin-bottom: -20px;
    }
}
</style>